import { Container } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import AdminControl from "../../components/AdminControl";
import AdminEvent from "../../components/AdminEvent";
import AdminMapResult from "../../components/AdminMapResult";
import AdminRecord from "../../components/AdminRecord";
import SubPage from "../../subpages/SubPage";

const EventManagement = () => {
  const title = "대회 관리";
  const parent_link = "admin/events"; // 반드시, 상대경로로 시작
  const side_list = [
    ["event", "기본 정보"],
    ["control", "기록 관리"],
    ["record", "순위 확정"],
    // ['course', '코스 관리'],
  ];
  const bg_info = {
    link: "https://user-images.githubusercontent.com/46194004/123917479-ce698400-d9bd-11eb-9599-975e219cee76.png",
    text: title,
  };
  return (
    <div>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={false}
        background_info={bg_info}
      />
      <Container className="col-10 offset-2 ps-5">
        <Switch>
          <Route
            path={`/${parent_link}/${side_list[0][0]}`}
            component={AdminEvent}
            exact={true}
          />
          <Route
            path={`/${parent_link}/${side_list[1][0]}`}
            component={AdminControl}
          />
          <Route
            path={`/${parent_link}/${side_list[2][0]}`}
            component={AdminRecord}
          />
          {/* <Route
            path={`/${parent_link}/${side_list[3][0]}`}
            component={AdminCourse}
          /> */}
          <Route path={`/${parent_link}/map`} component={AdminMapResult} />
        </Switch>
      </Container>
    </div>
  );
};
export default EventManagement;
